<template>
  <div id="search-results-container">
    <div id="search-results">
      <div id="search-results-search-container">
        <div class="search-types-container">
          <button class="search-type" :class="{ 'search-selected': searchMWNF }"
            @click="handleTypeChange('mwnf')">
            MWNF Database Search
          </button>
          <button class="search-type" :class="{ 'search-selected': searchGoogle }"
            @click="handleTypeChange('google')">
            Google-powered Search
          </button>
        </div>
        <form id="search-results-search" @submit.prevent>
          <input
            id="search-results-search-input"
            type="search"
            v-model="input"
            :placeholder="`Results will be based on ${searchPlaceholder} Search`"
          />
          <button class="search-button" type="submit" @click="search($event)">
            <font-awesome-icon
              :icon="['fas', 'search']"
              id="search-results-search-icon"
            />
          </button>
        </form>
        <router-link :to="{ name: 'important-information' }">
          Important Information
        </router-link>
      </div>

      <!-- <div class="gcse-searchresults-only" data-gname="results"></div> -->
      <div id="google-results"></div>
      <div v-if="searchType === 'mwnf'">
        <LoaderComponent v-if="!loaded" />
        <div v-else class="mwnf-search-wrapper">
          <div
            id="top-page-navigation"
            class="page-navigation-wrapper"
            v-if="displayPageNavigation"
          >
            <PagesComponent
              :pageInfo="pageInfo"
              :navigatePage="navigatePage"
              :navigatePageDirect="navigatePageDirect"
            ></PagesComponent>
          </div>

          <!-- Show only if there are results available -->
          <div id="results-wrapper" v-if="resultsExist">
            <!-- Larger picture + details of currently focused object -->
            <!-- Show this section only on larger screens -->
            <div id="results-main-object" v-if="!lessThan974">
              <div id="main-object-photo-container">
                <img id="main-object-image"
                  :src="mainObject.images[0] ? mainObject.images[0].urlThumbnail : ''" />
              </div>
              <div id="main-object-description">
                <div id="main-object-name-date">
                  <p class="bold" v-html="mainObject.name"></p>
                  <p v-html="mainObject.dateDescription"></p>
                </div>
                <div id="main-object-partner-location">
                  <!-- <p class="bold">{{ mainObject.partnerName }}</p> -->
                  <p>{{ mainObject.locationName }}, {{ mainObject.countryName }}<span v-if="mainObject.projectName">, in <span class="project-name-italic">{{ mainObject.projectName }}</span> {{ mainObject.from }}</span></p>
                </div>
              </div>
            </div>

            <!-- Thumbnail results of search -->
            <div id="results-container">
              <div
                class="result-wrapper"
                v-for="(result, index) in searchResults"
                :key="`${index}-${result.citation}`"
                :class="`result-${index + 1}`"
              >
                <div class="result">
                  <a :href="result.resultLink" target="_blank"
                    class="result-image-wrapper"
                  >
                    <!-- Hover changes "main" object display -->
                    <img
                      class="result-image"
                      :src="result.images[0] ? result.images[0].urlThumbnail : ''"
                      @mouseover="mainObject = result"
                    />
                  </a>
                  <div class="result-details">
                    <a :href="result.resultLink" target="_blank"
                      class="result-image-wrapper"
                    >
                      <span
                        class="bold"
                        @mouseover="mainObject = result"
                        v-html="result.name"
                      ></span>
                      <span>, {{ result.locationName }}, {{ result.countryName }}<span v-if="result.projectName">, in <span class="project-name-italic">{{ result.projectName }}</span> {{ result.from }}</span></span>
                    </a>
                    <!-- <p class="italic" v-html="result.dateDescription"></p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Show if there are no results -->
          <div id="search-no-results" v-else>
            <div id="no-results-text">
              <p>No results found (placeholder text).</p>
            </div>
          </div>

          <div
            id="bottom-page-navigation"
            class="page-navigation-wrapper"
            v-if="displayPageNavigation"
          >
            <PagesComponent
              :pageInfo="pageInfo"
              :navigatePage="navigatePage"
              :navigatePageDirect="navigatePageDirect"
            ></PagesComponent>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import audit from "../mixins/truncate.js";
import LoaderComponent from "../components/LoaderComponent.vue";
import PagesComponent from "../components/PagesComponent.vue";
import media from "../mixins/media.js";
import pageDisplay from "../mixins/pageDisplay.js";
export default {
  name: "SearchResults",
   components: {
    LoaderComponent: LoaderComponent,
    PagesComponent: PagesComponent,
  },
  mixins: [audit, media, pageDisplay],
  title: "Search Results | Explore with MWNF",
  data() {
    return {
      lessThan974: window.matchMedia("(max-width: 974px)").matches,
      input: this.$route.query.q,
      searchType: this.$route.params.type,
      localSearchType: this.$route.params.type,
      baseURL: process.env.VUE_APP_API_ENDPOINT,
      // baseURL: "https://explore.museumwnf.org/api",
      searchGoogle: this.$route.params.type === "google" ? true : false,
      searchMWNF: this.$route.params.type === "mwnf" ? true : false,
      searchPlaceholder: "MWNF Database",
      searchResults: [],
      resultsExist: false,
      // Path, current/last page, total pages, etc.
      pageInfo: {},
      // Links to first/last/next/previous pages
      pages: {},
      displayPageNavigation: false,
      mainObject: {},
      loaded: false,
    };
  },
  watch: {
    $route(to, from) {
      this.$global.lastSearchType = to.params.type;
      this.searchType = to.params.type;
      this.localSearchType = to.params.type,
      console.log(this.searchType);
      this.input = this.$route.query.q;
      console.log("search type updated in route watcher");
      this.handleSearch();
    },
  },
  methods: {
    handleTypeChange: function (type) {
      if (type === 'google') {
        this.localSearchType = "google";
        this.searchGoogle = true;
        this.searchMWNF = false;
        this.searchPlaceholder = "Google Custom";
      } else if (type === 'mwnf') {
        this.localSearchType = "mwnf";
        this.searchGoogle = false;
        this.searchMWNF = true;
        this.searchPlaceholder = "MWNF Database";
      }
      console.log(this.localSearchType, this.$global.lastSearchType);
    },
    handleSearch: function () {
      console.log(this.searchType);
      this.loaded = false;
      console.log("clearing div?");
      document.getElementById("google-results").innerHTML = "";
      // Only run if search type is Google
      if (this.searchType === 'google') {
        console.log("google function running");
        google.search.cse.element.render({
          div: "google-results",
          tag: "searchresults-only",
          gname: "results"
        });
        let query = this.$route.query.q;
        let cse = google.search.cse.element;
        let results = cse.getElement("results");
        results.execute(query);
        this.loaded = true;
      // Run if search type is MWNF
      } else if (this.searchType === 'mwnf') {
        let url = `${this.baseURL}/search?q=${this.input}`;
        if (this.$route.query.page) {
          let page = `&page=${this.$route.query.page}`;
          url = url + page;
        }
        console.log(url);
        return axios({ method: "GET", url: url }).then(
          (result) => {
            this.searchResults = this.createEntries(result.data.results);
            if (this.searchResults.length > 0) {
              this.resultsExist = true;
            } else {
              this.resultsExist = false;
            }
            // Main object is set to first object initially
            this.mainObject = this.searchResults[0];
            this.pageInfo = result.data.meta;
            this.pages = result.data.links;
            this.setDisplayPageNavigation();
            this.loaded = true;
          }, (error) => {
            console.error(error);
          }
        );
      }
    },
    createEntries: function (results) {
      let newResults = [];
      for (let i = 0; i < results.length; i++) {
        // // Add new field for link (can't easily overwrite citation)
        // results[i].resultLink = results[i].citation;
        // // Push in main result
        // newResults.push(results[i]);
        // // Create extra entries if there are related Explore links
        // if (results[i].relatedExploreMonuments) {
        //   for (let j = 0; j < results[i].relatedExploreMonuments.length; j++) {
        //     let copy = JSON.parse(JSON.stringify(results[i]));
        //     // Reassign citation link to Explore link
        //     copy.resultLink = results[i].relatedExploreMonuments[j].exploreLinks;
        //     newResults.push(copy);
        //   }
        // }

        // if (results[i].relatedExploreMonuments) {
        //   results[i].resultLink = results[i].relatedExploreMonuments[0].exploreLinks;
        // } else {
        //   results[i].resultLink = results[i].citation;
        // }
        if (!results[i].name && results[i].title) {
          results[i].name = this.audit(JSON.stringify(results[i].title));
        } else {
          results[i].name = this.audit(JSON.stringify(results[i].name));
        }
        results[i].countryName = this.audit(results[i].countryName);
        results[i].resultLink = results[i].citation;
        newResults.push(results[i]);
      }
      return newResults;
    },
    search: function (e) {
      e.preventDefault();
      if (this.input === "") {
        alert("Please enter a search term!");
        return;
      }
      if (this.$global.lastSearchType === this.localSearchType && this.input === this.$route.query.q) {
        alert("The results for this search term are already being displayed!");
        return;
      }
      this.$router.push({ name: "search", params: { type: this.localSearchType }, query: { q: this.input } });
    },
    navigatePage: function (page) {
      let url;
      if (page === "first") {
        url = this.pages.first;
      } else if (page === "last") {
        url = this.pages.last;
      } else if (page === "next") {
        url = this.pages.next;
      } else if (page === "previous") {
        url = this.pages.prev;
      }
      return axios({ method: "GET", url: url }).then(
        (result) => {
          this.searchResults = this.createEntries(result.data.results);
          this.pageInfo = result.data.meta;
          this.pages = result.data.links;
          let currentQuery = JSON.parse(JSON.stringify(this.$route.query));
          let updateQuery = currentQuery;
          updateQuery["page"] = this.pageInfo.current_page;
          this.$router.push({ name: "search", params: { type: this.searchType }, query: updateQuery });
        },
        (error) => {
          console.error(error);
        }
      );
    },
    // Navigate directly to a page by clicking a number
    navigatePageDirect: function (page) {
      let currentQuery = JSON.parse(JSON.stringify(this.$route.query));
      let updateQuery = currentQuery;
      updateQuery["page"] = page;
      this.$router.push({ name: "search", params: { type: this.searchType }, query: updateQuery });
    },
  },
  mounted() {
    // Custom Google search
    window.__gcse = {
      parsetags: "explicit",
      initializationCallback: () => {
        this.handleSearch();
      },
    };

    let script = document.createElement("script");
    script.src =
      "https://cse.google.com/cse.js?cx=011100841504088668422:r2cl-my4ubm";
    script.async = true;
    script.id = "script";
    document.head.appendChild(script);
  },
};
</script>

<style scoped lang="scss">
// Google search results are controlled their console, not here

#search-results-container {
  @include flex-center;
  background-color: white;
  width: 100%;
}
#search-results {
  @include flex-center;
  flex-direction: column;
  width: 100%;
  padding: 50px;
}

#search-results-search-container {
  @include flex-center;
  flex-direction: column;
  width: 70%;
  padding: 0 15px;
  margin-bottom: 50px;
}
.search-types-container {
  @include flex-center;
  justify-content: space-evenly;
  width: 80%;
  position: relative;
}
  .search-type {
    @include button-styles;
    position: relative;
    height: 50px;
    width: 50%;
    font-weight: bold;
    color: white;
    background-color: $dark-blue;
    border: 2px solid $dark-blue;
    border-bottom: 0;
    border-radius: 10px 10px 0 0;
    margin: 0 5px;
  }
  .search-type::before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(black, 0.3);
    border: 2px solid rgba(black, 0.3);
    border-radius: 10px 10px 0 0;
  }
    // .search-selected {
    //   color: $orange;
    //   // background-color: white;
    // }
    .search-type.search-selected::before {
      background-color: transparent;
      border: none;
    }
#search-results-search {
  display: flex;
  width: 100%;
}
#search-results-search-input {
  @include font-size-6;
  height: 50px;
  width: 100%;
  border: 1px solid $dark-blue;
  border-radius: 5px;
  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.25);
  padding: 6px 10px;
  margin-right: 5px;
}
#search-results-search-input::placeholder {
  @include headings;
  @include font-size-5;
  font-weight: normal;
  color: $medium-grey;
}
#search-results-search-input:focus {
  color: $dark-blue;
  z-index: 5;
}
.search-button {
  color: white;
  background-color: $dark-blue;
  border: 1px solid $dark-blue;
}
#search-results-search-container a {
  color: $dark-blue;
  margin: 10px;
}

#google-results {
  width: 70%;
}
#results-wrapper {
  @include flex-center;
  align-items: flex-start;
  padding: 0 50px;
}

#results-main-object {
  width: 25%;
  padding: 30px 0;
}
#main-object-photo-container {
  margin-bottom: 15px;
}
#main-object-image {
  @include image-scale;
  object-fit: contain;
  max-height: 400px;
}
#main-object-name-date {
  margin-bottom: 15px;
}
.project-name-italic {
  font-style: italic;
}

#results-container {
  width: 75%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px 30px;
  padding: 30px 0 30px 40px;
}
.result {
  @include flex-center;
  justify-content: flex-start;
  min-height: 120px;
}
.result a {
  text-decoration: none;
  color: $dark-green;
}
.result-image {
  @include image-scale;
  object-fit: contain;
  height: 120px;
  width: 150px;
  border: 1px solid rgba($medium-grey, 0.2);
}
.result-details {
  @include flex-center;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  padding-left: 10px;
}
.result-details a {
  margin-bottom: 5px;
}
.result-details a:hover {
  @include link-hover-styles;
}

#search-no-results {
  padding: 50px 50px 0 50px;
}
#search-no-results button {
  @include button-styles;
  // @include link-styles;
  // @include font-11;
  text-decoration: underline;
}
#search-no-results button:hover {
  @include link-hover-styles;
}
#no-results-text p {
  margin-bottom: 15px;
}

#results-padding {
  padding-bottom: 75px;
}

@media only screen and (max-width: 1199px) {
  #results-search-input {
    width: 60%;
  }
  .results-search-button {
    width: 16%;
  }
  .result {
    min-height: 175px;
  }
  .result-image {
    height: 175px;
    width: 120px;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 1199px),
  (-ms-high-contrast: active) and (max-width: 1199px) {
  .result-image-wrapper {
    height: 175px;
    width: 120px;
  }
  .result-image {
    height: auto;
    width: auto;
  }
  .result-details {
    width: calc(100% - 120px - 10px);
  }
}

@media only screen and (max-width: 974px) {
  #search-header-container {
    flex-direction: column;
    align-items: flex-start;
  }
  #search-info-container {
    width: auto;
  }
  #results-search-container {
    width: auto;
    margin-top: 20px;
  }
  #results-search-container form {
    justify-content: flex-start;
  }
  #results-search-input {
    min-width: 225px;
  }
  #how-to-link-container {
    align-self: flex-start;
  }
  #results-container {
    width: 100%;
    padding-left: 0;
  }
  .result {
    min-height: 135px;
  }
  .result-image {
    height: 135px;
    width: 150px;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 974px),
  (-ms-high-contrast: active) and (max-width: 974px) {
  .result-image-wrapper {
    height: 135px;
    width: 150px;
  }
  .result-image {
    height: auto;
    width: auto;
  }
  .result-details {
    width: calc(100% - 150px - 10px);
  }
}

@media only screen and (max-width: 849px) {
  // Increase height to make more room for text
  .result {
    min-height: 175px;
  }
  .result-image {
    height: 175px;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 849px),
  (-ms-high-contrast: active) and (max-width: 849px) {
  .result-image-wrapper {
    height: 175px;
  }
  .result-image {
    height: auto;
  }
}

@media only screen and (max-width: 724px) {
  .search-types-container {
    width: 95%;
  }
  #results-container {
    @include flex-center;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 20px;
  }
  .result-wrapper {
    width: 100%;
  }
  .result {
    min-height: 200px;
    width: 100%;
    margin-bottom: 20px;
  }
  .result a {
    width: 38%;
  }
  .result-image {
    height: 200px;
    width: 100%;
  }
  .result-details {
    width: 62%;
  }
}

/* IE-only */
@media only screen and (-ms-high-contrast: none) and (max-width: 724px),
  (-ms-high-contrast: active) and (max-width: 724px) {
  .result-image-wrapper {
    height: 200px;
    width: 100%;
  }
  .result-image {
    height: auto;
    width: auto;
  }
}

@media only screen and (max-width: 599px) {
  #back {
    padding: 30px 30px 0 30px;
  }
  #search-header-container {
    padding: 0 30px;
  }
  #results-wrapper {
    padding: 0 30px;
  }
  .result-details a {
    width: 100%;
  }
  #search-no-results {
    padding: 30px 30px 0 30px;
  }
}

@media only screen and (max-width: 499px) {
  .search-types-container {
    @include font-size-7;
  }
  #results-search-container {
    width: 100%;
  }
  #results-search-container form {
    @include flex-center;
    flex-direction: column;
    width: 100%;
  }
  #results-search-input {
    min-width: 0;
    width: 100%;
    margin-right: 0;
  }
  #search-buttons-container {
    justify-content: flex-start;
    width: 100%;
    margin-top: 10px;
  }
  .results-search-button {
    padding: 4px 8px;
  }
  .result {
    flex-direction: column;
    min-height: 250px;
  }
  .result a {
    height: 65%;
    width: 100%;
  }
  .result-image {
    height: 100%;
  }
  .result-details {
    height: 35%;
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
  }
  .result-details a {
    height: auto;
  }
}

@media only screen and (max-width: 399px) {
  .result {
    min-height: 225px;
  }
}



@media only screen and (max-width: 1349px) {
  #search-results-search-container,
  #google-results {
    width: 80%;
  }
}

@media only screen and (max-width: 1199px) {
  #search-results-search-container,
  #google-results {
    width: 90%;
  }
}

@media only screen and (max-width: 949px) {
  #search-results-search-container,
  #google-results {
    width: 100%;
  }
  #search-results-search-input::placeholder {
    @include font-size-6;
  }
}

@media only screen and (max-width: 749px) {
  #search-results, 
  #search-results-search-container {
    padding: 30px;
  }
  #search-results-search-container {
    margin-bottom: 15px;
  }
}
</style>
